import { formatFileSize } from "@interface48/formatting";

export const getFileDescription = (fileName: string, fileSizeBytes: number): string => {
  return `${fileName!} (${formatFileSize(fileSizeBytes!)})`;
};
